$.getUrlParameters = function (parameter) {
	var results = new RegExp('[\?&]' + parameter + '=([^&#]*)').exec(window.location.href);
	if (results == null) {
		return null;
	}
	else {
		return results[1] || 0;
	}
}

// When the user clicks on the button, scroll to the top of the document
function gotoTop() {
	$('html, body').stop(true, false).animate({
		scrollTop:0
	}, 1000);
};

function scrollToSection(sid) {

	var div = $(sid);
	var elemTop = div.offset().top / 2 + 120;

	c
	return false;

}

function isTouchOn() {
	return (('ontouchstart' in window) || (navigator.maxTouchPoints > 0) || (navigator.msMaxTouchPoints > 0));
}

function showHideConsent() {
	if (localStorage.getItem('CCE-ls-consent')){
		$('.cookie_consent').attr('data-dismiss-cookie', localStorage.getItem('CCE-ls-consent'));
	}
}

function showHideFavourites() {
	var total = 0;
	var aLabel = '';
	// set favourite links for resources
	if (localStorage.getItem('CCE-ls-resources') != '') {
		lsResources = JSON.parse(localStorage.getItem('CCE-ls-resources')) || [];
		total += lsResources.length;
		//console.log('fav resources: ' + total);
		if (window.location.pathname.indexOf('favourites') < 0) {
			$('.favourite_toggle.resource').each(function () {
				//console.log('resId: ' + $(this).attr('id'));
				if (lsResources.indexOf($(this).attr('id')) !== -1) {
					$(this).find('.label').text('Remove favourite');
					aLabel = $(this).find('.btn-text').text();
					$(this).find('.btn-text').text(aLabel.replace('Add "', 'Remove "').replace('to favourites.', 'from favourites.'));
					$(this).attr('aria-pressed', 'true');
				}
			});
		}
	}

	// set favourite links for events
	if (localStorage.getItem('CCE-ls-events') != '') {
		lsEvents = JSON.parse(localStorage.getItem('CCE-ls-events')) || [];
		total += lsEvents.length;
		//console.log('fav events: ' + lsEvents);
		if (window.location.pathname.indexOf('favourites') < 0) {
			$('.favourite_toggle.event').each(function () {
				if (lsEvents.indexOf($(this).attr('id')) !== -1) {
					$(this).find('.label').text('Remove favourite');
					aLabel = $(this).find('.btn-text').text();
					//console.log('fav events: ' + aLabel);
					$(this).find('.btn-text').text(aLabel.replace('Add "', 'Remove "').replace('to favourites.', 'from favourites.'));
					$(this).attr('aria-pressed', 'true');
				}
			});
		}
	}

	$('#header-menu .header_menu li:last-child').attr('data-number', total.toString());
}

function addOrRemoveFavouritItem() {
	$(document).off('click.favourite', '.favourite_toggle')
		.on('click.favourite', '.favourite_toggle', function (event) {
			event.preventDefault();

			var favItems = [];
			var itemId = $(this).attr('id');
			var label = $(this).find('.label').text().toLowerCase();
			var isResource = $(this).hasClass('resource');

			favItems = isResource ? lsResources : lsEvents;

			var aLabel = '';

			if (favItems.indexOf(itemId) !== -1 && label == 'remove favourite') {
				favItems.splice(favItems.indexOf(itemId), 1);

				if (window.location.pathname.indexOf('favourites') > -1) {
					$(this).closest('.card_content').remove();

					if ($('.card_content').length === 0) {
						$('#favListingsContainer').html(
							'<div id="noResultsText" class="row">' +
							'<div class="col-md-12 text-left ml-4 mt-4 mb-3">' +
							'<p>Sorry there are no results matching your search.</p>' +
							'</div>' +
							'</div>'
						);

						$('#exportFavourites').hide();
						$('.sortby').hide();
					}
				} else {
					$(this).find('.label').text('Favourite');
					$(this).attr('aria-pressed', 'false');

					aLabel = $(this).find('.btn-text').text();
					$(this).find('.btn-text').text(
						aLabel.replace('Remove "', 'Add "')
							.replace('from favourites.', 'to favourites.')
					);
				}
			} else {
				favItems.push(itemId);

				$(this).find('.label').text('Remove favourite');
				$(this).attr('aria-pressed', 'true');

				aLabel = $(this).find('.btn-text').text();
				$(this).find('.btn-text').text(
					aLabel.replace('Add "', 'Remove "')
						.replace('to favourites.', 'from favourites.')
				);
			}

			var lsName = isResource ? 'CCE-ls-resources' : 'CCE-ls-events';
			localStorage.setItem(lsName, JSON.stringify(favItems));

			showHideFavourites();
		});
}

function showMoreLessDescription() {
	$('.link_toggle').on('click', function () {
		console.log('expand: ' + $(this).attr('aria-expanded') + '/' + $(this).parent().parent().find('.text_collapse').attr('class'));
		var $text_collapse = $(this).parent().parent().find('.text_collapse');
		if ($(this).attr('aria-expanded') == 'true') {
			$text_collapse.removeClass('ellipsis');
		}
		else {
			$text_collapse.addClass('ellipsis');
		}
		return false;
	});
}

function populateHubsNav(def) {
	var hubs = [
		{
			"name": "cce",
			"svg": "unifiednav_cce",
			"alt": "Civics and citizenship",
			"url": "https://www.civicsandcitizenship.edu.au/"
		},
		{
			"name": "dth",
			"svg": "unifiednav_dth",
			"alt": "Digital Technologies Hub",
			"url": "https://www.digitaltechnologieshub.edu.au/"
		},
		{
			"name": "ella", 
			"svg": "unifiednav_ella",
			"alt": "Early Learning Languages Australia",
			"url": "https://www.ella.edu.au/"
		},
		{
			"name": "lih",
			"svg": "unifiednav_lih",
			"alt": "Literacy Hub",
			"url": "https://www.literacyhub.edu.au/"
		},
		{
			"name": "mah",
			"svg": "unifiednav_mah",
			"alt": "Mathematics Hub",
			"url": "https://www.mathematicshub.edu.au/"
		},
		{
			"name": "sch",
			"svg": "unifiednav_sch",
			"alt": "Social Cohesion Hub",
			"url": "https://www.socialcohesionhub.edu.au/"
		},
		{
			"name": "swh",
			"svg": "unifiednav_swh",
			"alt": "Student Wellbeing Hub",
			"url": "https://studentwellbeinghub.edu.au/"
		}
	];

	var html = '<div class="container">';
	for (const hub of hubs) {
		if (hub.name == def) {
			html += '<a href="#" class="hub" aria-current="page">';
			html += '<span class="visually-hidden">' + hub.alt + '(curent page)</span>';
			html += '<img src="/Frontend/Images/hub-logos/' + hub.svg + '.svg" alt="" style="width:100%; height:auto;">';
			html += '</a>';
		} else {
			html += '<a href="' + hub.url + '" class="hub" target="_blank" aria-labelledby="' + hub.name + '-link-text">';
			html += '<span class="visually-hidden" id="' + hub.name + '-link-text">' + hub.alt + '(opens in a new tab)</span>';
			html += '<div class="logo_wrapper">';
			html += '<img src="/Frontend/Images/hub-logos/' + hub.svg + '-gs.svg" alt="" class="logo_default" aria-hidden="true" style="width:100%; height:auto;">';
			html += '<img src="/Frontend/Images/hub-logos/' + hub.svg + '.svg" alt="" class="logo_hover" aria-hidden="true" style="width:100%; height:auto;">';
			html += '</div>';
			html += '</a>';
		}
	}
	html += "</div>";
	$('.hubs_nav').html(html);
}

function closeActiveMenu($openMenu) {
	const menuId = $openMenu.attr('id');
	const $toggleButton = $('[data-bs-target="#' + menuId + '"]');

	$toggleButton.attr('aria-expanded', 'false');
	$openMenu.collapse('hide');
	$('body').removeClass('blockScroll');

	// Explicitly send focus back to the button so the user isn't lost
	$toggleButton.focus();
}

/* start */
$(function () {
	var lsResources = [];
	var lsEvents = [];
	var resultSortby = 'Recently post';
	/* Store the window width */
	var windowWidth = $(window).width();
	//console.log('page:' + window.location.pathname);
	
	populateHubsNav('cce');

	if ($('#maintenance-notification')){
		$('#close-notification-btn').on('click', function () {
			$('#maintenance-notification').addClass('hide');
		});
	}

	/* Hero block - Force Jaws to play video icon when tab back from the text link */
	if ($('.video_desc').length) {	
		$('.video_desc').find('.video_link').on('keydown', function (e) {

			// Check if the user is pressing Shift + Tab
			if (e.shiftKey && (e.key === 'Tab' || e.keyCode === 9)) {								


				// Look UP the DOM tree to find this specific button's parent card, 
				// then look DOWN to find its matching first button.
				var $firstBtn = $(this).closest('.video_desc').find('.play_btn');

				// Verify the first button actually exists in this card
				if ($firstBtn.length) {
					e.preventDefault(); // Stop Chrome's broken spatial/flexbox focus calculation
					$firstBtn.focus();   // Force native browser focus onto the first button
				}
			}
		});
	}

	$(window).on('resize', function (e) {
		// Check if the window width has actually changed and it's not just iOS triggering a resize event on scroll
		if ($(window).width() != windowWidth) {
			// Update the window width for next time
			windowWidth = $(window).width();
			// setTimeout(function () {
			// 	if (parseInt(windowWidth) < 992) {
			// 		$('#header-menu').addClass('collapse');
			// 	} else {
			// 		$('#header-menu').removeClass('collapse');
			// 	}
			// }, 50);
		}
	}).on('blur', function () {
		// Un-focus whatever field is currently active right as they leave
		$(document.activeElement).blur();
	});	


	let $button = null;
	let $menu = null;
	const focusableSelectors = 'a, button, input, [tabindex="0"]';

	// TOGGLE MENU, FILTERS
	$('[data-toggle="menu"]').on('click', function (e) {
		e.preventDefault();
		var menuId = $(this).attr('data-target');
		//console.log('menu :', menuId);
		const $menu = $($(this).attr('data-target'));
		if ($(this).hasClass('close')) {
			$menu.removeAttr('role').removeAttr('aria-modal').removeClass('show');
			$('body').removeClass('blockScroll');
			//console.log('close: ', menuId);		
		} else {
			$menu.addClass('show');	
			$menu.attr('role', 'dialog').attr('aria-modal', 'true');		
			$('body').addClass('blockScroll');
			// CRITICAL: Find the first interactive element inside and focus it immediately
			if (focusableSelectors.length) {
				setTimeout(function () {
					$menu.find(focusableSelectors).filter(':visible').first().focus();
				}, 50);
			}
			//console.log('open: ', menuId);
		}
	});

	// -------------------------
	// Handling keyword clear btn & keyword focus 
	// -------------------------
	$(document).ready(function () {
		// handling top menu search button  
		// Trigger search on click of the search button
		$('#btnSearchTop').on('click', function () {
			var query = $('#keywords').val().trim();
			var searchUrl = (query) ? `/search/?keywords=${encodeURIComponent(query)}` : '/search/';
			// Mimics the exact same behavior as the native GET form submission
			window.location.href = searchUrl;
		});

		//Trigger search on pressing 'Enter' inside the input field
		$('#keywords').on('keydown', function (e) {
			if (e.key === 'Enter') {
				$('#btnSearchTop').trigger('click');
			}
		});

		$(document).on('input', '#keywords, #txtKeywords', function (e) {
			/* clear keyword search */
			let currentText = $(this).val();
			//console.log('check:', $(this).attr('id'));
			let $clearBtn = $(this).siblings('.clear-keyword');

			if (currentText.length > 0) {
				$clearBtn.removeClass('hide');
			} else {
				$clearBtn.addClass('hide');
			}

		})

		// Clear Button & Search Field Focus Management Fix
		// ------------------------------------------------
		.on('click', '.clear-keyword', function (e) {
			/* clear keyword search */
			$(this).addClass('hide');
			$(this).prev('input').val('').addClass('outline').focus();

		}).on('keypress', '#txtKeywords', function (e) {
			/*trigger search page*/
			if (e.which === 13) {
				//console.log('txt: ', $(this).attr('id'));
				e.preventDefault();
				$('#btnSearch').click();
			}
		});
	});

	// -------------------------
	// Focus trap for top & filters menu
	// -------------------------
	$('#header-menu, .filterSearch_grid').on('keydown', function (e) {
		const $focusable = $(this).find('a, button, input, select, textarea, [tabindex]:not([tabindex="-1"])').filter(':visible');
		const currentIndex = $focusable.index(document.activeElement);
		const firstEl = $focusable.first()[0];
		const lastEl = $focusable.last()[0];
		const activeEl = document.activeElement;
		if (currentIndex === -1) {
			return;
		}
		if ($(this).hasClass('show')) {
			let nextIndex;
			switch (e.key) {
				case 'Tab':
					e.preventDefault();
					if (e.shiftKey) {
						// Shift + Tab
						//nextIndex = (currentIndex - 1 + $focusable.length) % $focusable.length;
						nextIndex = activeEl === firstEl ? $focusable.length - 2 : currentIndex - 1;
					} else {
						// Tab
						//nextIndex = (currentIndex + 1) % $focusable.length;
						nextIndex = activeEl === lastEl ? 1 : currentIndex + 1; 
					}
					break;

				case 'ArrowDown':
					e.preventDefault();
					//nextIndex = (currentIndex + 1) % $focusable.length;
					nextIndex = currentIndex + 1;
					//console.log('arr down: ', $(this).attr('id'), currentIndex, '/', nextIndex, $focusable.attr('class'));
					break;

				case 'ArrowUp':
					e.preventDefault();
					//nextIndex = (currentIndex - 1 + $focusable.length) % $focusable.length;
					nextIndex = currentIndex - 1;
					break;

				case 'Escape':
					e.preventDefault();
					$(this).removeAttr('role').removeAttr('aria-modal').removeClass('show');
					$('body').removeClass('blockScroll');
					$(this).prev('button[data-target="#' + $(this).attr('id') + '"]').focus();
					break;

				default:
					return;
			}

			$focusable.eq(nextIndex).focus();
		}
	});
	// -------------------------
	// SYNC WITH BOOTSTRAP (IMPORTANT)
	// -------------------------
	$('.collapse').on('shown.bs.collapse', function () {
		console.log('bootstrap show: ');// + $button.attr('class') + ' ' + $menu.attr('id'));
	});

	$('.collapse').on('hidden.bs.collapse', function () {

		console.log('bootstrap close: ');// + $button.attr('class') + ' ' + $menu.attr('id'));
	});


	/*stop video when modal is closed */
	$('body').on('hidden.bs.modal', function (e) {
		var $iframes = $(e.target).find("iframe");
		$iframes.each(function (index, iframe) {
			$(iframe).attr("src", $(iframe).attr("src"));
		});
	});

	if ($.getUrlParameters('clear', 'location') != null) {
		localStorage.clear();
	}
	
	//cookie-values
	showHideFavourites();
	showHideConsent();

	$('#cookie-consent').on('click', function () {
		var today = new Date();
		var day = ("0" + today.getDate()).slice(-2);
		var month = ("0" + (today.getMonth() + 1)).slice(-2);
		var year = today.getFullYear();
		var formattedDate = day + month + year;
		localStorage.setItem('CCE-ls-consent', formattedDate);
		showHideConsent();
	});


	if ($('.favourite_toggle').length > 0) {
		addOrRemoveFavouritItem();
	}

	if ($('.results_content.resources').length > 0) {

		$('#sortby-sel').attr('title', resultSortby).on('change', function () {
			//console.log('site:' + $(this).val());
			resultSortby = $(this).val();
		});
	}

	/* change header height when scroll */
	$(window).on('scroll', function () {
		if ($(this).scrollTop() > 20) {
			$('#back-to-top').addClass('show');
			$('#back-to-top').on('click', function () {
				gotoTop();
			});
		} else {
			$('#back-to-top').removeClass('show');
		}
	});	

	// Standalone looping handler strictly for Arrow Up and Arrow Down
	$('.container').on('keydown', function (e)
	{
		if (e.key !== 'ArrowDown' && e.key !== 'ArrowUp') return;

			const items = [];

		$(this).find('.hamburger.close:not(.sec)').each(function () { items.push(this); });
		$(this).find('.header_menu a').each(function () { items.push(this); });
		$(this).find('.nav_search #keywords').each(function () { items.push(this); });
		$(this).find('.nav_search #btnSearchTop').each(function () { items.push(this); });
		$(this).find('.hamburger.close.sec').each(function () { items.push(this); });

		if (items.length === 0) return;

		const activeEl = document.activeElement;
		const currentIndex = items.findIndex(el => el === activeEl || el.contains(activeEl));

		if (currentIndex === -1) return;

		e.preventDefault();

		let nextIndex;

		if (e.key === 'ArrowDown')
		{
			nextIndex = (currentIndex + 1) % items.length;
		} else if (e.key === 'ArrowUp')
		{
			nextIndex = (currentIndex - 1 + items.length) % items.length;
		}

		if (items[nextIndex])
		{
			items[nextIndex].focus();
		}
	});

});

